import script from "./billingRulePage.vue?vue&type=script&setup=true&lang=js"
export * from "./billingRulePage.vue?vue&type=script&setup=true&lang=js"

import "./billingRulePage.vue?vue&type=style&index=0&id=64123c24&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64123c24"]])

export default __exports__